import { useReducer } from "react";

export const initial: State = {
	filterName: ""
};

export interface State {
	filterName: string;
}

enum ActionType {
	onChangeFilterName = "onChangeFilterName"
}

interface Action {
	type: string;
	val: string;
}

function reducer(state: State, action: Action): State {
	switch (action.type) {
		case ActionType.onChangeFilterName:
			return {
				...state,
				filterName: action.val
			};
		default:
			throw new Error();
	}
}

export default function useUnknownActionsStore() {
	const [state, dispatch] = useReducer(reducer, initial);

	const actions = {
		onChangeFilterName: (val: string) =>
			dispatch({
				type: ActionType.onChangeFilterName,
				val
			})
	};

	return [state, actions] as const;
}
